import Service from '@/service/index.js';
export default {
  components: {
  },
  props: ['item', 'index', 'transferType', 'projectType', 'projectSubType', 'needtoShow'],
  data() {
    return {
      massifTypeArr: []
    };
  },
  created() {
    const obj = {
      MASSIF_TYPE: 'massifTypeArr'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
  },
  computed: {
  },
  methods: {
  }
};
